module.exports = __webpack_public_path__ + "static/media/parachute_lg.2f159a6f.svg";